export default __webpack_public_path__ + "static/media/menu.1ac77947.svg";